import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const LuvlyUsers = lazyWithPreload(() => import('./LuvlyUsers'))
